module.exports = __webpack_public_path__ + "img/login-kuang.440a5229.png";